module.exports={
  "type": "FeatureCollection",
  "crs": {
    "type": "name",
    "properties": {
      "name": "urn:ogc:def:crs:EPSG::4269"
    }
  },

  "features": [{
    "type": "Feature",
    "properties": {
      "type": null,
      "address": "Rainier Ave. S. & S. Rose St.",
      "city": "Seattle",
      "state": "WA",
      "CaseNum": "15-00280",
      "NameFirst": "“Baby Girl Paige”",
      "NameMiddle": null,
      "NameLast": null,
      "AgeYrs": null,
      "DeathDate": "6\/18\/2015",
      "InjuryDesc": "A fetus identified as Baby Girl Paige died from a gunshot wound that struck her head, arm and umbilical cord when her 19-year-old mother was shot in the abdomen at a bus stop on Rainier Avenue South. Her mother survived. Seattle police classified the death as a homicide, but it was classified as a “fetal death“ by the King County Medical Examiner's Office.",
      "StoryLink": "http:\/\/www.seattletimes.com\/seattle-news\/crime\/pregnant-woman-shot-early-friday-in-dunlap-neighborhood\/",
      "Mode": "Homicide",
      "PoliceOrg": "Seattle Police Department",
      "Charged": "A fetus identified as Baby Girl Paige died from a gunshot wound that struck her head, arm and umbilical cord when her 19-year-old mother was shot in the abdomen at a bus stop on Rainier Avenue South. Her mother survived. Seattle police classified the death as a homicide, but it was classified as a “fetal death“ by the King County Medical Examiner's Office.",
      "order": 8
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-122.269977, 47.529141]
    }
  }, {
    "type": "Feature",
    "properties": {
      "type": null,
      "address": "1811 Eastlake Ave.",
      "city": "Seattle",
      "state": "WA",
      "CaseNum": "15-00280",
      "NameFirst": "Kenny",
      "NameMiddle": null,
      "NameLast": "Lofton",
      "AgeYrs": "47 years old",
      "DeathDate": "9\/26\/2015",
      "InjuryDesc": "",
      "StoryLink": "http://www.seattletimes.com/seattle-news/crime/seattle-agency-investigating-deadly-fight-at-housing-facility/",
      "Mode": "Homicide",
      "PoliceOrg": "Seattle Police Department",
      "Charged": "Lofton, a resident of a supportive-housing facility for formerly homeless people with alcohol issues, was drinking heavily when he challenged a 55-year-old resident to a fight. The men exchanged punches and Lofton was kicked twice in the head but declined medical aid from a facility staff member. He later died at Harborview. The 55-year-old was booked into jail, then released; prosecutors decided not to criminally charge him because it appears he acted in self-defense.",
      "order": 19
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-122.329556, 47.618203]
    }
  }, {
    "type": "Feature",
    "properties": {
      "type": null,
      "address": "2305 1st Ave.",
      "city": "Seattle",
      "state": "WA",
      "CaseNum": "15-00280",
      "NameFirst": "Thomas",
      "NameMiddle": "A.",
      "NameLast": "Hess",
      "AgeYrs": "53 years old",
      "DeathDate": "2\/14\/2015",
      "InjuryDesc": "Found in uncertain circumstances with injuries consistent with probable mechanical asphyxia",
      "StoryLink": null,
      "Mode": "Homicide",
      "PoliceOrg": "Seattle Police Department",
      "Charged": "Hess was found “in uncertain circumstances“ in his Belltown apartment, according to death investigators. He suffocated after his airway was somehow cut off. No one has been arrested.",
      "order": 1
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-122.346946, 47.613474]
    }
  }, {
    "type": "Feature",
    "properties": {
      "type": null,
      "address": "8500 block 12th S. (alley)",
      "city": "Seattle",
      "state": "WA",
      "CaseNum": null,
      "NameFirst": "Celina",
      "NameMiddle": "Anne",
      "NameLast": "Petersen",
      "AgeYrs": "27 years old",
      "DeathDate": "2\/15\/2015",
      "InjuryDesc": "Assaulted by other(s).",
      "StoryLink": "http:\/\/blogs.seattletimes.com\/today\/2015\/02\/woman-found-in-south-park-alley-identified\/",
      "Mode": "Homicide",
      "PoliceOrg": "Seattle Police Department",
      "Charged": "A passerby found Petersen fatally beaten in an alley in South Park and called police. No one has been arrested.",
      "order": 2
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-122.317541, 47.527315]
    }
  }, {
    "type": "Feature",
    "properties": {
      "type": null,
      "address": "3900 Burke Ave. N.",
      "city": "Seattle",
      "state": "WA",
      "CaseNum": null,
      "NameFirst": "Biftu",
      "NameMiddle": null,
      "NameLast": "Dadi",
      "AgeYrs": "24 years old",
      "DeathDate": "3\/8\/2015",
      "InjuryDesc": "Stabbed by other.",
      "StoryLink": "http:\/\/www.seattletimes.com\/seattle-news\/man-who-drove-womans-body-to-hospital-charged-with-second-degree-murder\/",
      "Mode": "Homicide",
      "PoliceOrg": "Seattle Police Department",
      "Charged": "Dadi suffered at least 7 stab wounds to her chest and throat while sleeping in her parked vehicle. Attila Richards, who had met Dadi a week earlier, is accused of killing her, then driving her body from Seattle to Lakewood, where he attempted to turn himself in at Western State Hospital. Charged with second-degree murder, Richards, now 30, was found competent to stand trial in December.",
      "order": 3
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-122.335052, 47.65434]
    }
  }, {
    "type": "Feature",
    "properties": {
      "type": null,
      "address": "800 Yesler Way",
      "city": "Seattle",
      "state": "WA",
      "CaseNum": null,
      "NameFirst": "Margaret",
      "NameMiddle": "Mary",
      "NameLast": "Pitka",
      "AgeYrs": "41 years old",
      "DeathDate": "3\/14\/2015",
      "InjuryDesc": "Shot by other",
      "StoryLink": null,
      "Mode": "Homicide",
      "PoliceOrg": "Seattle Police Department",
      "Charged": "Pitka, who was homeless, was napping in her tent when a gunman fired through the flap, striking Pitka in the neck and torso. Dung Hoang Nguyen was arrested four days later and charged with second-degree murder and first-degree unlawful possesion of a firearm. He had been in Seattle for two months at the time of the shooting and has criminal convictions in California and Nevada.",
      "order": 4
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-122.322445, 47.601717]
    }
  }, {
    "type": "Feature",
    "properties": {
      "type": null,
      "address": "15th Ave. S. & S. Forest St.",
      "city": "Seattle",
      "state": "WA",
      "CaseNum": null,
      "NameFirst": "Robert",
      "NameMiddle": null,
      "NameLast": "Robinson Jr.",
      "AgeYrs": "17 years old",
      "DeathDate": "3\/15\/2015",
      "InjuryDesc": "Shot by other.",
      "StoryLink": "http:\/\/www.seattletimes.com\/seattle-news\/crime\/seattle-drive-by-shooting-victim-dreamed-of-success-friends-say\/",
      "Mode": "Homicide",
      "PoliceOrg": "Seattle Police Department",
      "Charged": "Robinson, a senior at Cleveland High School, was killed in a drive-by shooting on Beacon Hill. No suspects arrested.",
      "order": 5
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-122.313364, 47.577755]
    }
  }, {
    "type": "Feature",
    "properties": {
      "type": null,
      "address": "3rd Ave. & Pine St.",
      "city": "Seattle",
      "state": "WA",
      "CaseNum": null,
      "NameFirst": "John",
      "NameMiddle": "G",
      "NameLast": "Williams",
      "AgeYrs": "24 years old",
      "DeathDate": "3\/19\/2015",
      "InjuryDesc": "Shot by other(s).",
      "StoryLink2": "http://www.seattletimes.com/seattle-news/crime/suspect-charged-in-fatal-shooting-of-kent-toddler/",
      "StoryLink": " http://www.seattletimes.com/seattle-news/crime/babys-death-in-kent-drive-by-may-be-linked-to-gang-feud/",
      "Mode": "Homicide",
      "PoliceOrg": "Seattle Police Department",
      "Charged": "Seattle police found Williams wounded in the street and he died from gunshot wounds three days later at Harborview. Williams, reportedly a senior member of the Low Profile street gang, appears to have been killed as part of an ongoing beef with members of the rival Deuce 8 street gang. No arrests have been made.",
      "order": 6
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-122.338703, 47.610741]
    }
  }, {
    "type": "Feature",
    "properties": {
      "type": null,
      "address": "4200 12th Ave. N.E.",
      "city": "Seattle",
      "state": "WA",
      "CaseNum": null,
      "NameFirst": "Blake",
      "NameMiddle": "Howard",
      "NameLast": "Long",
      "AgeYrs": "29 years old",
      "DeathDate": "4\/30\/2015",
      "InjuryDesc": "Shot by other.",
      "StoryLink": null,
      "Mode": "Homicide",
      "PoliceOrg": "Seattle Police Department",
      "Charged": "Seattle police believe Long was fatally shot somewhere else before his body, wrapped in a sleeping bag and plastic, was discovered in an alley in the University District. No one has been arrested.",
      "order": 7
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-122.315515, 47.658406]
    }
  }, {
    "type": "Feature",
    "properties": {
      "type": null,
      "address": "500 S. Weller St.",
      "city": "Seattle",
      "state": "WA",
      "CaseNum": null,
      "NameFirst": "Benito",
      "NameMiddle": "J.",
      "NameLast": "Enriquez",
      "AgeYrs": "30 years old",
      "DeathDate": "6\/27\/2015",
      "InjuryDesc": "Assaulted by other",
      "StoryLink": "http://www.seattletimes.com/seattle-news/crime/nurse-dies-from-injuries-in-attack-near-centurylink-field/",
      "Mode": "Homicide",
      "PoliceOrg": "Seattle Police Department",
      "Charged": "Enriquez, who worked as a nurse, died at Harborview after being fatally beaten following a Jason Aldean concert at Century Link Field. No arrests have been made.",
      "order": 9
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-122.327647, 47.597534]
    }
  }, {
    "type": "Feature",
    "properties": {
      "type": null,
      "address": "900 24th Ave.",
      "city": "Seattle",
      "state": "WA",
      "CaseNum": null,
      "NameFirst": "Torrence",
      "NameMiddle": "L.",
      "NameLast": "Spillers",
      "AgeYrs": "30 years old",
      "DeathDate": "7\/2\/2015",
      "InjuryDesc": "Shot by other",
      "StoryLink": "http://www.seattletimes.com/seattle-news/crime/seattle-police-investigating-central-district-shooting/",
      "StoryLink2": "http://www.capitolhillseattle.com/2015/07/man-shot-at-24th-and-spring/",
      "Mode": "Homicide",
      "PoliceOrg": "Seattle Police Department",
      "Charged": "Several people called 911 to report hearing multiple gunshots and responding officers found Spillers dead on the ground. No one has been arrested.",
      "order": 10
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-122.301062, 47.61017]
    }
  }, {
    "type": "Feature",
    "properties": {
      "type": null,
      "address": "3030 N.E. 143rd St.",
      "city": "Seattle",
      "state": "WA",
      "CaseNum": null,
      "NameFirst": "Kwame",
      "NameMiddle": null,
      "NameLast": "Ansah-Yiadom",
      "AgeYrs": "37 years old",
      "DeathDate": "7\/5\/2015",
      "InjuryDesc": "Shot by other",
      "StoryLink": null,
      "Mode": "Homicide",
      "PoliceOrg": "Seattle Police Department",
      "Charged": "A security guard was making his rounds when he discovered Ansah-Yiadom dead from gunshot wounds in a parking lot. No arrests have been made.",
      "order": 11
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-122.294978, 47.732266]
    }
  }, {
    "type": "Feature",
    "properties": {
      "type": "OIS",
      "address": "6500 Ravenna Ave. N.E.",
      "city": "Seattle",
      "state": "WA",
      "CaseNum": null,
      "NameFirst": "Samuel",
      "NameMiddle": "T.",
      "NameLast": "Smith",
      "AgeYrs": "27 years old",
      "DeathDate": "7\/17\/2015",
      "InjuryDesc": "Shot during confrontation with law enforcement.",
      "StoryLink": "http://www.seattletimes.com/seattle-news/crime/police-looking-for-black-car-after-officer-involved-i-5-hit-and-run/",
      "StoryLink2": "http://www.seattletimes.com/seattle-news/crime/gentle-soul-mother-friend-perplexed-by-actions-of-knife-wielding-man-killed-by-officer/",
      "Mode": "Homicide",
      "PoliceOrg": "Seattle Police Department",
      "Charged": "Smith rammed his Mazda into a Seattle police car on Interstate 5, forcing it into the median before speeding off. Officers started searching for the vehicle, which was found by Officer Shaun Hilton in Ravenna. Hilton fatally shot Smith after Smith ran at the officer with a 16-inch knife, an incident captured by a police dashboard camera.",
      "order": 12
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-122.303624, 47.67591]
    }
  }, {
    "type": "Feature",
    "properties": {
      "type": null,
      "address": "800 S. Lane St.",
      "city": "Seattle",
      "state": "WA",
      "CaseNum": null,
      "NameFirst": "Donald",
      "NameMiddle": "Gregory",
      "NameLast": "Chin",
      "AgeYrs": "59 years old",
      "DeathDate": "7\/23\/2015",
      "InjuryDesc": "Shot by other",
      "StoryLink": " http://www.seattletimes.com/seattle-news/crime/investigation-continues-into-death-of-donnie-chin-chinatown-international-district-activist/",
      "StoryLink2": "http://www.seattletimes.com/seattle-news/obituaries/donald-chin-spent-life-protecting-serving-the-chinatown-international-district/",
      "Mode": "Homicide",
      "PoliceOrg": "Seattle Police Department",
      "Charged": "A longtime community activist in the International District, Chin was responding to a report of gunfire when he was caught in the crossfire between two rival groups, according to Seattle police. Chin was not the intended target and no one has been arrested in connection with his death.",
      "order": 13
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-122.322444, 47.596677]
    }
  }, {
    "type": "Feature",
    "properties": {
      "type": null,
      "address": "44th Ave. S. & S. Cloverdale St.",
      "city": "Seattle",
      "state": "WA",
      "CaseNum": null,
      "NameFirst": "Zakariya",
      "NameMiddle": "I.",
      "NameLast": "Issa",
      "AgeYrs": "20 years old",
      "DeathDate": "7\/31\/2015",
      "InjuryDesc": "Shot by other",
      "StoryLink": "http://www.seattletimes.com/seattle-news/crime/killing-after-funeral-was-result-of-friendship-gone-bad-charging-papers-say/",
      "Mode": "Homicide",
      "PoliceOrg": "Seattle Police Department",
      "Charged": "Issa was walking home from a friend's funeral and talking on his cell phone with his mom when Mohammed Omar allegedly jumped out of the passenger seat of a BMW, confronted Issa and punched him in the face; after Issa fell to the ground, police say Omar shot him three times in the head. Omar was charged with first-degree murder and Antonio Pablo Brown, who allegedly witnessed the shooting and drove Omar from the scene, was charged with first-degree rendering criminal assistance.",
      "order": 14
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-122.278064, 47.526118]
    }
  }, {
    "type": "Feature",
    "properties": {
      "type": null,
      "address": "E. Columbia St. & 26th Ave.",
      "city": "Seattle",
      "state": "WA",
      "CaseNum": null,
      "NameFirst": "Antonio",
      "NameMiddle": "L.",
      "NameLast": "Jones",
      "AgeYrs": "24 years old",
      "DeathDate": "8\/13\/2015",
      "InjuryDesc": "Shot by other(s).",
      "StoryLink": "http://www.seattletimes.com/seattle-news/crime/man-walking-his-dog-is-slain-in-central-district/",
      "Mode": "Homicide",
      "PoliceOrg": "Seattle Police Department",
      "Charged": "Jones was at his grandmother's house and took his dog for a walk when he was fatally shot by a gunman from a car that then sped off. No one has been arrested.",
      "order": 15
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-122.298843, 47.609015]
    }
  }, {
    "type": "Feature",
    "properties": {
      "type": null,
      "address": "Pine St. & Melrose Ave.",
      "city": "Seattle",
      "state": "WA",
      "CaseNum": null,
      "NameFirst": "Ramon",
      "NameMiddle": "E.",
      "NameLast": "Mitchell",
      "AgeYrs": "23 years old",
      "DeathDate": "8\/16\/2015",
      "InjuryDesc": "Shot by other",
      "StoryLink": "http://www.seattletimes.com/seattle-news/crime/man-killed-in-capitol-hill-shootout-identified/",
      "StoryLink2": " http://www.capitolhillseattle.com/2015/08/homicide-detectives-seek-tips-in-investigation-of-deadly-shooting-outside-baltic-room/",
      "Mode": "Homicide",
      "PoliceOrg": "Seattle Police Department",
      "Charged": "Mitchell was killed in a shootout between several groups of people in a parking lot across from The Baltic Room on Capitol Hill. Mitchell was the son of Ritchie “OG Ratt“ Williams, a Crips gang member who was fatally shot in the head in 2013. No one has been arrested in connection with Mitchell's death.",
      "order": 16
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-122.327904, 47.615229]
    }
  }, {
    "type": "Feature",
    "properties": {
      "type": null,
      "address": "10 Denny Way",
      "city": "Seattle",
      "state": "WA",
      "CaseNum": null,
      "NameFirst": "Wafi",
      "NameMiddle": "Tariq",
      "NameLast": "Kilaouy",
      "AgeYrs": "22 years old",
      "DeathDate": "8\/22\/2015",
      "InjuryDesc": "Shot by other(s).",
      "StoryLink": null,
      "Mode": "Homicide",
      "PoliceOrg": "Seattle Police Department",
      "Charged": "Kilaouy was fatally shot and two other men were seriously injured inside a parked car at a gas station at Denny Way and Queen Anne Ave North. It appears a gunfight may have occured inside the vehicle and homicide detectives haven't ruled out the possibility the shooting was motivated by a drug robbery. No one has been charged in connection with his death.",
      "order": 17
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-122.356355, 47.618942]
    }
  }, {
    "type": "Feature",
    "properties": {
      "type": null,
      "address": "15th Ave. W. & W. Garfield St.",
      "city": "Seattle",
      "state": "WA",
      "CaseNum": null,
      "NameFirst": "Stacey",
      "NameMiddle": "Joemarie",
      "NameLast": "Davis",
      "AgeYrs": "48 years old",
      "DeathDate": "8\/24\/2015",
      "InjuryDesc": "Assaulted by other.",
      "StoryLink": "http://www.seattletimes.com/seattle-news/crime/man-suspected-of-beating-woman-to-death-shot-by-seattle-police/",
      "StoryLink2": "http://www.seattletimes.com/seattle-news/crime/man-charged-with-2nd-degree-murder-in-magnolia-bridge-beating/",
      "Mode": "Homicide",
      "PoliceOrg": "Seattle Police Department",
      "Charged": "Davis and her husband were living in a tent under the Magnolia Bridge when police say a man living in their homeless encampment attacked the couple with a homemade club. Davis suffered multiple skull fractures and broken bones. Her husband was able to run away and summon help. Allen Pulphus, 53, was shot in the leg by a SWAT officer after a standoff with police. He has been charged with second-degree murder and first-degree assault for the attack on Davis' husband.",
      "order": 18
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-122.376184, 47.633496]
    }
  }, {
    "type": "Feature",
    "properties": {
      "type": null,
      "address": "6500 California Ave. S.W.",
      "city": "Seattle",
      "state": "WA",
      "CaseNum": null,
      "NameFirst": "Drue",
      "NameMiddle": "Carlos",
      "NameLast": "Lehto",
      "AgeYrs": "17 months old",
      "DeathDate": "9\/27\/2015",
      "InjuryDesc": "Inflicted blunt force injury.",
      "StoryLink": "http://www.seattletimes.com/seattle-news/crime/west-seattle-woman-investigated-in-death-of-toddler/",
      "Mode": "Homicide",
      "PoliceOrg": "Seattle Police Department",
      "Charged": "Lehto was a few months shy of his 2nd birthday when he was found unresponsive in his crib. His father's girlfriend, Alicia Goematt, 21, has been charged with second-degree murder, accused of kicking the toddler so hard in the stomach that his liver, pancreas and intestines tore. His father had left Lehto with Goematt when he went to buy gas and cigarettes.",
      "order": 20
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-122.387208, 47.544853]
    }
  }, {
    "type": "Feature",
    "properties": {
      "type": null,
      "address": "1000 4th Ave. S.",
      "city": "Seattle",
      "state": "WA",
      "CaseNum": null,
      "NameFirst": "Damon",
      "NameMiddle": "Maurice",
      "NameLast": "Brown",
      "AgeYrs": "45 years old",
      "DeathDate": "10\/9\/2015",
      "InjuryDesc": "Shot by other.",
      "StoryLink": "http://www.seattletimes.com/seattle-news/crime/early-morning-shooting-in-sodo-under-investigation/",
      "Mode": "Homicide",
      "PoliceOrg": "Seattle Police Department",
      "Charged": "Seattle police responded to a report of gunfire and found Brown lying on the ground at a bus stop at Fourth Avenue South and South Royal Brougham Way. Brown, who was fatally shot, was reportedly a resident of The Jungle homeless encampment. No arrests have been made.",
      "order": 21
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-122.328454, 47.594304]
    }
  }, {
    "type": "Feature",
    "properties": {
      "type": null,
      "address": "Rainier Ave. S. & S. Garden St.",
      "city": "Seattle",
      "state": "WA",
      "CaseNum": null,
      "NameFirst": "Abubakar",
      "NameMiddle": "Abdulkadir",
      "NameLast": "Abdi",
      "AgeYrs": "20 years old",
      "DeathDate": "10\/11\/15",
      "InjuryDesc": "Shot by other.",
      "StoryLink": "http://www.seattletimes.com/seattle-news/crime/seattle-man-charged-with-killing-stranger-after-minor-argument/",
      "Mode": "Homicide",
      "PoliceOrg": "Seattle Police Department",
      "Charged": "Abdi was fatally shot following a minor argument with a stranger outside a Shell gas station. Police allege Michael “Big Easy“ Henderson followed Abdi and his friends across the street, fatally shot Abdi at close range, then walked away. Henderson has been charged with second-degree murder. ",
      "order": 22
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-122.27042, 47.537645]
    }
  }, {
    "type": "Feature",
    "properties": {
      "type": null,
      "address": "6900 23rd Ave. S.W.",
      "city": "Seattle",
      "state": "WA",
      "CaseNum": null,
      "NameFirst": "Jerome",
      "NameMiddle": "N.",
      "NameLast": "Jackson",
      "AgeYrs": "24 years old",
      "DeathDate": "10\/24\/2015",
      "InjuryDesc": "Shot by other(s).",
      "StoryLink": "http://www.seattletimes.com/seattle-news/crime/high-point-slaying-suspect-held-bail-set-at-1-million/",
      "Mode": "Homicide",
      "PoliceOrg": "Seattle Police Department",
      "Charged": "Jackson was fatally shot in the throat and a 34-year-old man was shot in the face but survived. Though a 24-year-old South Seattle man was arrested following the shooting, he has not been criminally charged and his case is still being reviewed by prosecutors. Jackson and the 24-year-old had reportedly been fighting over a $200 drug debt for five years.",
      "order": 23
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-122.362345, 47.541719]
    }
  }, {
    "type": "Feature",
    "properties": {
      "type": "OIS",
      "address": "N.E. 68th St. & 35th Ave. N.E.",
      "city": "Seattle",
      "state": "WA",
      "CaseNum": null,
      "NameFirst": "Raymond",
      "NameMiddle": null,
      "NameLast": "Azevedo",
      "AgeYrs": "35 years old",
      "DeathDate": "12\/6\/2015",
      "InjuryDesc": "Shot by other(s) during confrontation with police.",
      "StoryLink": "http://www.seattletimes.com/seattle-news/crime/spd-releases-new-details-on-fatal-shooting-of-carjacker/",
      "Mode": "Homicide",
      "PoliceOrg": "Seattle Police Department",
      "Charged": "Azevedo was fatally shot by Seattle police after reportedly car jacking a couple vehicles and leading police on a wild pursuit through several Seattle neighborhoods. The incident was captured by police dash-board cameras.",
      "order": 25
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-122.290313, 47.677611]
    }
  }, {
    "type": "Feature",
    "properties": {
      "type": null,
      "address": "3517 S. Brandon St.",
      "city": "Seattle",
      "state": "WA",
      "CaseNum": null,
      "NameFirst": "Christy",
      "NameMiddle": "Nguyen",
      "NameLast": "Phu",
      "AgeYrs": "14 years old",
      "DeathDate": "12\/6\/2015",
      "InjuryDesc": "Shot by other.",
      "StoryLink": "http://www.seattletimes.com/seattle-news/crime/2m-bail-for-man-suspected-of-killing-his-niece-over-sneakers/",
      "Mode": "Homicide",
      "PoliceOrg": "Seattle Police Department",
      "Charged": "Christy Phu was fatally shot in the head while folding laundry with her cousin in the bedroom the two girls shared. Phu's 24-year-old uncle, Si Phu, was charged with first-degree murder with a firearm enhancement and second-degree unlawful possession of a firearm. He is accused of killing his niece because she refused to give him a pair of shoes bought for her by her father.",
      "order": 24
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-122.288195, 47.553225]
    }
  }, {
    "type": "Feature",
    "properties": {
      "type": null,
      "address": "2119 3rd Ave.",
      "city": "Seattle",
      "state": "WA",
      "CaseNum": null,
      "NameFirst": "Brent",
      "NameMiddle": "Edward",
      "NameLast": "McDonald",
      "AgeYrs": "49 years old",
      "DeathDate": "12\/13\/2015",
      "InjuryDesc": null,
      "StoryLink": "http://www.seattletimes.com/seattle-news/crime/slaying-of-popular-seattle-art-teacher-was-unprovoked-charges-say/",
      "Mode": "Homicide",
      "PoliceOrg": "Seattle Police Department",
      "Charged": "McDonald, a popular art teacher and youth mentor in the Central District, was fatally shot while walking on a Belltown sidewalk. Police arrested Richard Charles Whitaker, 55, nearly four weeks later on a Metro bus and say he shot McDonald for no apparent reason. Whitaker is charged with second-degree murder.",
      "order": 26
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-122.343067, 47.613519]
    }
  }]
}
